import {
  Stack,
  Typography,
  Grid,
  Paper,
  Box,
  Chip,
  Tooltip,
} from '@mui/material'
import { 
  Male,
  Female,
  Cake,
  Pets,
  ColorLens,
} from '@mui/icons-material'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime';


const EntryOverviewTab = ({ entry }) => {
  const formatDate = (dateString) => {
    if (!dateString) return 'Not specified'
    return new Date(dateString).toLocaleDateString()
  }
  dayjs.extend(relativeTime)

  const getPhaseColor = (phase) => {
    switch (phase) {
      case 'chick': return 'warning'
      case 'juvenile': return 'info'
      case 'adult': return 'success'
      default: return 'default'
    }
  }

  const getSexIcon = (sex) => {
    return sex === 'male' ? <Male fontSize="small" /> : <Female fontSize="small" />
  }

  console.log("entry", entry)

  return (
    <Stack spacing={3}>
      <Typography variant="h6" gutterBottom>
        Basic Information
      </Typography>
      
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Paper variant="outlined" sx={{ p: 3, height: '100%' }}>
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
              Identity
            </Typography>
            <Stack spacing={2}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">Age</Typography>
                <Tooltip title={`Hatch Date: ${entry.hatchDate || 'Unknown'}`} placement="top" arrow={true}>
                <Typography variant="body1" sx={{ fontWeight: 'medium' }}>
                  {dayjs().to(dayjs(entry.hatchDate), true) || 'Unnamed'}
                  </Typography>
                  </Tooltip>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">Species</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <Pets fontSize="small" color="action" />
                  <Typography variant="body1">{entry?.species || 'Not specified'}</Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">Breed</Typography>
                <Typography variant="body1">{entry?.breed || 'Not specified'}</Typography>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">Sex</Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  {entry?.sex && getSexIcon(entry.sex)}
                  <Typography variant="body1" sx={{ textTransform: 'capitalize' }}>
                    {entry?.sex || 'Not specified'}
                  </Typography>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">Phase</Typography>
                {entry?.phase ? (
                  <Chip 
                    icon={<Cake />}
                    label={entry.phase}
                    color={getPhaseColor(entry.phase)}
                    size="small"
                    sx={{ textTransform: 'capitalize' }}
                  />
                ) : (
                  <Typography variant="body1">Not specified</Typography>
                )}
              </Box>
            </Stack>
          </Paper>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <Paper variant="outlined" sx={{ p: 3, height: '100%' }}>
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
              Status & Classification
            </Typography>
            <Stack spacing={2}>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">Mother</Typography>
                {entry.mother? entry.mother : 'Unknown'}
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">Father</Typography>
                {entry.father? entry.father : 'Unknown'}
              </Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Typography variant="body2" color="text.secondary">Entry ID</Typography>
                <Typography variant="body2" sx={{ fontFamily: 'monospace', fontSize: '0.75rem' }}>
                  {entry?.entryId?.slice(0, 8)}...
                </Typography>
              </Box>
            </Stack>
          </Paper>
        </Grid>

        {entry?.characteristics && entry.characteristics.length > 0 && (
          <Grid size={{ xs: 12 }}>
            <Paper variant="outlined" sx={{ p: 3 }}>
              <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1 }}>
                <ColorLens color="primary" />
                Characteristics
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mt: 1 }}>
                {entry.characteristics.map((characteristic, index) => (
                  <Chip
                    key={index}
                    label={characteristic}
                    variant="outlined"
                    color="primary"
                    size="small"
                  />
                ))}
              </Box>
            </Paper>
          </Grid>
        )}

        {entry?.notes?.active && (
          <Grid size={{ xs: 12 }}>
            <Paper variant="outlined" sx={{ p: 3 }}>
              <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 'bold' }}>
                Current Notes
              </Typography>
              <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap' }}>
                {entry.notes.active}
              </Typography>
            </Paper>
          </Grid>
        )}
      </Grid>
    </Stack>
  )
}

export default EntryOverviewTab